import { useEffect } from 'react'

import Head from 'next/head'
import { Container } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/router'

import WishItem from '@/components/molecules/WishItem'

import ComponentStyled from './styled'

type Props = {
  onConfirm: () => void
  user: string
  avatar: string
  wish: string
  location: string
}

const CONFIRM_DELAY = 8000

const FinishWish = ({ onConfirm, user, avatar, wish, location }: Props): JSX.Element => {
  const { t } = useTranslation()
  const { locale } = useRouter()

  useEffect(() => {
    setTimeout(() => {
      onConfirm()
    }, CONFIRM_DELAY)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ComponentStyled>
      {locale === 'fr' && (
        <Head>
          <script
            id='fr-script'
            type='text/javascript'
            dangerouslySetInnerHTML={{
              __html: `
                  zemApi('track', 'lead');`,
            }}
          />
          <noscript>
            <img
              src='https://p1.zemanta.com/v2/p/ns/53943/lead/'
              referrerPolicy='no-referrer-when-downgrade'
              height='1'
              width='1'
              alt=''
            />
          </noscript>
        </Head>
      )}
      <Container maxWidth='xl'>
        <div className='wish-finish-box'>
          <p className='finish-title'>{t('thanks for your help!')}</p>
          <p className='finish-desc'>
            {t(
              'You ad +1 year to crop preservation and biodiversity. Our objective is to reach 50.000 wishes to conserve 500 crops for 100 years.'
            )}
          </p>
          <div className='wish-wrapper'>
            <WishItem username={user} avatar={avatar} comment={wish} location={location} />
          </div>
        </div>
      </Container>
    </ComponentStyled>
  )
}

export default FinishWish
